import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "c-sitemenu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "MENU", -1)
const _hoisted_3 = {
  key: 0,
  class: "top-mobile"
}
const _hoisted_4 = { class: "internal-link__body" }
const _hoisted_5 = { class: "internal-link" }
const _hoisted_6 = { class: "internal-link__icon" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "internal-link" }
const _hoisted_9 = { class: "internal-link__icon" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "internal-link" }
const _hoisted_12 = { class: "internal-link__icon" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "internal-link" }
const _hoisted_15 = { class: "internal-link__icon internal-link__icon--red" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "c-burgermenu-content" }
const _hoisted_18 = {
  key: 1,
  class: "bottom-mobile"
}
const _hoisted_19 = { class: "internal-link" }
const _hoisted_20 = { class: "internal-link__icon internal-link__icon--darken" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "internal-link" }
const _hoisted_23 = { class: "internal-link__icon internal-link__icon--darken" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "internal-link" }
const _hoisted_26 = { class: "internal-link__icon internal-link__icon--darken" }
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "context__head" }, null, -1)
const _hoisted_29 = { class: "context__content" }
const _hoisted_30 = { class: "top" }
const _hoisted_31 = { class: "internal-link" }
const _hoisted_32 = { class: "internal-link__icon" }
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "internal-link" }
const _hoisted_35 = { class: "internal-link__icon" }
const _hoisted_36 = ["href"]
const _hoisted_37 = { class: "internal-link" }
const _hoisted_38 = { class: "internal-link__icon" }
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "internal-link" }
const _hoisted_41 = { class: "internal-link__icon internal-link__icon--red" }
const _hoisted_42 = ["href"]
const _hoisted_43 = { class: "bottom" }
const _hoisted_44 = { class: "internal-link" }
const _hoisted_45 = { class: "internal-link__icon internal-link__icon--darken" }
const _hoisted_46 = ["href"]
const _hoisted_47 = { class: "internal-link" }
const _hoisted_48 = { class: "internal-link__icon internal-link__icon--darken" }
const _hoisted_49 = ["href"]
const _hoisted_50 = { class: "internal-link" }
const _hoisted_51 = { class: "internal-link__icon internal-link__icon--darken" }
const _hoisted_52 = ["href"]

import { computed, ref } from "vue";

// Components
import SlideInObject from "@/vue/components/objects/SlideInObject.vue";
import Burgermenu from "./objects/Burgermenu.vue";

//Icons
import BurgerIcon from "@web/assets/icon/burger.svg";
import ChevronIcon from "@web/assets/icon/chevron.svg";
import TagIcon from "@web/assets/icon/tag.svg";
import HeartIcon from "@web/assets/icon/favorite.svg";
import StarIcon from "@web/assets/icon/star.svg";
import PercentIcon from "@web/assets/icon/percent.svg";
import EmailIcon from "@web/assets/icon/email.svg";
import QuestionIcon from "@web/assets/icon/question.svg";
import TransportIcon from "@web/assets/icon/transport.svg";
import CloseIcon from "@web/assets/icon/close.svg";

import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'SiteMenu',
  props: {
	navPages: {
		type: Array,
	},
	internalPages: {
		type: Object,
	},
},
  setup(__props) {

const store = useStore();

const translations = computed(() => store.state.translations.siteTranslations);

// Define prop
const props = __props;

const isOpen = ref(false);
const currentViewLevel = ref(1);

const parentStack = ref([]);
const currentParent = ref("");
const pathStack = ref([]);
const currentViewPages = ref([]);

//Store icon components for internal links dynamic <component> rendering
const componentsArray = [
	{ key: "tag", component: TagIcon },
	{ key: "favorite", component: HeartIcon },
	{ key: "star", component: StarIcon },
	{ key: "percent", component: PercentIcon },
	{ key: "email", component: EmailIcon },
	{ key: "question", component: QuestionIcon },
	{ key: "transport", component: TransportIcon },
];

function toggleSlideIn() {
	currentViewLevel.value = 1;
	isOpen.value = !isOpen.value;
}

function navigateBack() {
	parentStack.value.pop();
	currentParent.value = parentStack.value[parentStack.value.length - 1];

	pathStack.value.pop();
	currentViewPages.value = pathStack.value[pathStack.value.length - 1];
	currentViewLevel.value = pathStack.value.length + 1;
}

function navigateForward(levelPages: Array, parent: string) {
	setTimeout(() => {
		parentStack.value.push(parent);
		pathStack.value.push(levelPages);

		currentViewLevel.value = pathStack.value.length + 1;
		currentViewPages.value = levelPages;
		currentParent.value = parent;
	}, 5);
}

// Get the component by the internalpage iconKey
function getComponentByKey(iconKey: string) {
	const found = componentsArray.find(
		(iconComponent) => iconComponent.key === iconKey
	);
	return found ? found.component : null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", {
      class: "c-sitemenu__button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSlideIn()))
    }, [
      _createVNode(_unref(BurgerIcon)),
      _hoisted_2
    ]),
    _createVNode(SlideInObject, {
      "is-open": isOpen.value,
      "aria-label": "Site cart",
      placement: "left",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (toggleSlideIn()))
    }, {
      head: _withCtx(() => [
        _renderSlot(_ctx.$slots, "head"),
        _createElementVNode("div", null, [
          (currentViewLevel.value > 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "back-button",
                onClick: navigateBack
              }, [
                _createVNode(_unref(ChevronIcon)),
                _createTextVNode(" " + _toDisplayString(translations.value["back"]), 1)
              ]))
            : _createCommentVNode("", true),
          (currentViewLevel.value > 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "close-button",
                onClick: toggleSlideIn
              }, [
                _createVNode(_unref(CloseIcon))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      body: _withCtx(() => [
        (currentViewLevel.value <= 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.brandsPage.iconKey)), { class: "tag" }))
                  ]),
                  _createElementVNode("a", {
                    href: __props.internalPages.brandsPage.url
                  }, _toDisplayString(translations.value["popularBrands"]), 9, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.popularProducts.iconKey)), { class: "heart" }))
                  ]),
                  _createElementVNode("a", {
                    href: __props.internalPages.popularProducts.url
                  }, _toDisplayString(translations.value["popularProducts"]), 9, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.newsPage.iconKey)), { class: "star" }))
                  ]),
                  _createElementVNode("a", {
                    href: __props.internalPages.newsPage.url
                  }, _toDisplayString(translations.value["news"]), 9, _hoisted_13)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.offersPage.iconKey)), { class: "percent" }))
                  ]),
                  _createElementVNode("a", {
                    href: __props.internalPages.offersPage.url
                  }, _toDisplayString(translations.value["offersRightNow"]), 9, _hoisted_16)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(Burgermenu, {
            navPages: __props.navPages,
            currentParent: currentParent.value,
            currentViewLevel: currentViewLevel.value,
            currentViewPages: currentViewPages.value,
            onNavigateForward: navigateForward
          }, null, 8, ["navPages", "currentParent", "currentViewLevel", "currentViewPages"])
        ]),
        (currentViewLevel.value <= 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.contactPage.iconKey)), { class: "tag" }))
                ]),
                _createElementVNode("a", {
                  href: __props.internalPages.contactPage.url
                }, _toDisplayString(translations.value["contactCustomerService"]), 9, _hoisted_21)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.faqPage.iconKey)), { class: "question" }))
                ]),
                _createElementVNode("a", {
                  href: __props.internalPages.faqPage.url
                }, _toDisplayString(translations.value["faq"]), 9, _hoisted_24)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.deliveryPage.iconKey)), { class: "transport" }))
                ]),
                _createElementVNode("a", {
                  href: __props.internalPages.deliveryPage.url
                }, _toDisplayString(translations.value["deliveryAndReturns"]), 9, _hoisted_27)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => []),
      context: _withCtx(() => [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.brandsPage.iconKey)), { class: "tag" }))
              ]),
              _createElementVNode("a", {
                href: __props.internalPages.brandsPage.url
              }, _toDisplayString(translations.value["popularBrands"]), 9, _hoisted_33)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.popularProducts.iconKey)), { class: "heart" }))
              ]),
              _createElementVNode("a", {
                href: __props.internalPages.popularProducts.url
              }, _toDisplayString(translations.value["popularProducts"]), 9, _hoisted_36)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.newsPage.iconKey)), { class: "star" }))
              ]),
              _createElementVNode("a", {
                href: __props.internalPages.newsPage.url
              }, _toDisplayString(translations.value["news"]), 9, _hoisted_39)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.offersPage.iconKey)), { class: "percent" }))
              ]),
              _createElementVNode("a", {
                href: __props.internalPages.offersPage.url
              }, _toDisplayString(translations.value["offersRightNow"]), 9, _hoisted_42)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.contactPage.iconKey)), { class: "tag" }))
              ]),
              _createElementVNode("a", {
                href: __props.internalPages.contactPage.url
              }, _toDisplayString(translations.value["contactCustomerService"]), 9, _hoisted_46)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.faqPage.iconKey)), { class: "question" }))
              ]),
              _createElementVNode("a", {
                href: __props.internalPages.faqPage.url
              }, _toDisplayString(translations.value["faq"]), 9, _hoisted_49)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByKey(__props.internalPages.deliveryPage.iconKey)), { class: "transport" }))
              ]),
              _createElementVNode("a", {
                href: __props.internalPages.deliveryPage.url
              }, _toDisplayString(translations.value["deliveryAndReturns"]), 9, _hoisted_52)
            ])
          ])
        ])
      ]),
      _: 3
    }, 8, ["is-open"])
  ]))
}
}

})